export const apiListPrice = "/1.0/wsm/time/list"
export const apiCreatePrice = "/1.0/wsm/time/create"
export const apiDetailPrice = id => `/1.0/wsm/time/${id}/detail`
export const apiUpdatePrice = id => `/1.0/wsm/time/${id}/update`
export const apiUpdateList = id => `/1.0/wsm/setting/${id}/update`
